export enum Basketball3x3LineupPositions {
  Player = 'player',
  Coach = 'coach',
}
